import React from "react";
import { useMediaQuery } from "react-responsive";
import { getProPolk } from "../../backend/proPolk/proPolk";
import { sanitizeHTML } from "../../utils/htmlSanitizer";
import { Helmet } from "react-helmet-async";

const AboutUsPage = () => {
  const isSmall = useMediaQuery({query: `(max-width: 450px)`});
  const isMobile = useMediaQuery({query: `(max-width: 768px)`});
  const cropPhoto = useMediaQuery({query: `(max-width: 1300px)`});
  const addPadding = useMediaQuery({query: `(min-width: 1500px)`});

  const {title, quoteTop, quoteBottom, photo, logo, text} = getProPolk();

  return (
    <>
      <Helmet>
        <title>210 Окремий Штурмовий Полк | Про полк</title>
        <meta name="description" content="Інформація про створення 210го Окремого Штурмового Полку "/>
      </Helmet>
      <div style={{overflow: "hidden"}}>
        {/* ── Title row ── */}
        <div
          style={{
            ...styles.topRowWrapper,
            padding: isMobile
              ? "2rem var(--main-container-margin)"
              : "4rem var(--main-container-margin)",
          }}
        >
          <h1
            style={{
              ...styles.topHeading,
              fontSize: isMobile ? "3rem" : "5rem",
              lineHeight: isMobile ? "" : "5rem",
            }}
          >
            {title || "210 Окремий Штурмовий Полк"}
          </h1>
        </div>

        {/* ── Quote + photo row ── */}
        {/*<div style={styles.bottomRowWrapper}>*/}
        {/*  <p*/}
        {/*    style={{*/}
        {/*      ...styles.bottomHeading,*/}
        {/*      fontSize: isSmall ? "1.4rem" : isMobile ? "2.1rem" : "3rem",*/}

        {/*      paddingBottom:addPadding ? "2rem" : "2rem",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    {quoteTop || ""}*/}
        {/*  </p>*/}
        {/*  <p*/}
        {/*    style={{*/}
        {/*      ...styles.bottomSubHeading,*/}
        {/*      fontSize: isSmall ? "1.05rem" : isMobile ? "1.3rem" : "2.1rem",*/}
        {/*      paddingBottom: isMobile ? "2rem" : "2rem",*/}
        {/*      whiteSpace: "pre-line",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    {quoteBottom || ""}*/}
        {/*  </p>*/}
        {/*  {photo && (*/}
        {/*    <div style={{ position: "relative", height: "auto" }}>*/}
        {/*      <img*/}
        {/*        src={photo}*/}
        {/*        style={{*/}
        {/*          position: "absolute",*/}
        {/*          bottom: 0,*/}
        {/*          right: isSmall*/}
        {/*            ? "calc(-12rem + 20vw)"*/}
        {/*            : isMobile*/}
        {/*            ? "-9rem"*/}
        {/*            : cropPhoto*/}
        {/*            ? "calc(calc(100vw - 1450px)*0.5)"*/}
        {/*            : "-5rem",*/}
        {/*          width: isSmall ? "18.5rem" : isMobile ? "calc(20rem + 7vw)" : "30rem",*/}
        {/*          height: "auto",*/}
        {/*        }}*/}
        {/*        alt="командир полку"*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</div>*/}

        {/* ── Logo + text ── */}
        <div style={{...styles.bottomSection, padding: isMobile ? "2rem 0rem" : "4rem 0rem"}}>
          {logo && (
            <img
              src={logo}
              style={{maxWidth: "min(calc(var(--main-container-width)*0.8), 400px)"}}
              alt="герб полку"
            />
          )}
          <p
            style={{
              ...styles.bottomText,
              fontSize: isMobile ? "1.5rem" : "2.2rem",
              textAlign: isMobile ? "left" : "justify",
            }}
            dangerouslySetInnerHTML={{__html: sanitizeHTML(text || "")}}
          />
        </div>
      </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  topRowWrapper: {
    backgroundColor: "var(--olive)",
    width: "100%",
    padding: "4rem var(--main-container-margin)",
  },
  topHeading: {
    fontWeight: "bold",
    color: "var(--dark-grey)",
  },
  bottomRowWrapper: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--orange)",
    width: "100%",
    padding: "0 var(--main-container-margin)",
  },
  bottomHeading: {
    color: "var(--black)",
    maxWidth: "calc(var(--main-container-width) * 0.6)",
    paddingBottom: "2rem",
  },
  bottomSubHeading: {
    color: "var(--dark-grey)",
    maxWidth: "calc(var(--main-container-width) * 0.6)",
  },
  bottomSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2rem",
  },
  bottomText: {
    maxWidth: "935px",
    margin: "0 var(--main-container-margin)",
    fontSize: "2.5rem",
  },
};

export default AboutUsPage;